import { quoteActions } from '../constants/registry/quotes-table.constant';
import {
  DynamicTableBreakpoints,
  DynamicTableConfig,
} from '../interfaces/dynamic-table.interface';
import { compact } from 'lodash';

export const mmpiDashboardQuotesTablePreset = {
  columns: [
    { id: 'title' },
    {
      id: 'renewalDate',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 3,
        },
      },
    },
    {
      id: 'additionalRequests',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 4,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 5,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 7,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 5,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: [
          quoteActions['viewStatus'],
          quoteActions['viewClient'],
          quoteActions['assignToBroker'],
          quoteActions['viewProposal'],
          quoteActions['sendInvite'],
          quoteActions['editEnquiry'],
        ],
      },
    },
  ],
};

export const mmpiQuotesTablePreset: Partial<DynamicTableConfig> = {
  columns: compact([
    { id: 'title' },
    {
      id: 'renewalDate',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 3,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 2,
        },
      },
    },
    {
      id: 'assignedBroker',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 4,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 3,
        },
      },
    },
    {
      id: 'assignedContacts',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 5,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 4,
        },
      },
    },
    {
      id: 'additionalRequests',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 6,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 5,
        },
      },
    },
    {
      id: 'workflowStatus',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 7,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
          order: 6,
        },
      },
    },
    {
      id: 'lastActivity',
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: '0 0 50%',
          order: 8,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
          order: 7,
        },
      },
    },
    {
      id: 'contextMenu',
      props: {
        actions: compact([
          quoteActions['viewStatus'],
          quoteActions['viewClient'],
          quoteActions['assignToBroker'],
          quoteActions['assignContact'],
          quoteActions['viewProposal'],
          quoteActions['updateProposal'],
          quoteActions['sendInvite'],
          quoteActions['editEnquiry'],
          quoteActions['configureRenewal'],
        ]),
      },
    },
  ]),
};
